import { createRouter, createWebHashHistory, RouteRecordRaw } from "vue-router";
import HomeView from "@/views/HomeView.vue";
import RechnungDetailVue from "@/components/rechnung/RechnungDetail.vue";
import RechnungDashboardVue from "@/components/rechnung/RechnungDashboard.vue";

const routes: Array<RouteRecordRaw> = [
  {
    path: "/",
    name: "home",
    components: { default: HomeView },    
  },  
  {
    path: "/ControlCenter",
    name: "ControlCenter",
    component: () => import("@/views/ControlCenter.vue"),
  },
  {
    path: "/DocumentManagement",
    name: "DocumentManagement",
    component: () => import("@/views/DocumentManagement.vue"),
  },
  {
    path: "/ShowDeviceData",
    name: "ShowDeviceData",
    component: () => import("@/components/Device/ShowDeviceData.vue"),
  },
  {
    path: "/Rechnung",
    name: "rechnung",
    component: RechnungDashboardVue
  },
  {
    path: "/CreateCustomerDocuments",
    name: "CreateCustomerDocuments",
    component: () => import("@/components/Reports/CreateCustomerDocuments.vue"),
  },
  {
    path: "/Sos24AidInfo/:kundenLink",
    component: RechnungDetailVue,
    name: "customerLink",
    props: ["customerLink","Year"],
  },    
  {
    path: "/Auftrag",
    name: "auftrag",
    component: () => import("@/components/helpdesk/Sideeffects/AuftragsErfassung.vue")
    
  },
  {
    path: "/Plaene",
    name: "bereichDokument",
    component: () => import("@/components/dokumente/BereichDokumentView.vue")
  },
  {
    path: "/Berichte",
    name: "berichte",
    component: () =>import("@/views/Berichte.vue")
  },
  {
    path: "/stammdaten",
    name: "stammdaten",    
    component: () =>
      import("@/views/Stammdaten.vue"),      
      children: [
        {
          path: "/mobile",
          name: "mobile",
          components: { 
            default: () =>import("@/components/stammdaten/Queries/MobileSearch.vue"),
            content: () =>import("@/components/stammdaten/sideeffects/MobileEdit.vue")
          },
          children: [
            {
              path: "/VorlagenAnzeige",
              name: "vorlagen",
              components: { 
                info: () => import("@/components/stammdaten/Queries/VorlagenAnzeige.vue") 
              },              
            },  
          ],
        },
        {
          path: "/geraet",
          name: "geraet",
          components: { 
            default: () =>import("@/components/stammdaten/Queries/GeraeteSearch.vue"),
            content: () =>import("@/components/stammdaten/sideeffects/GeraeteEdit.vue")
          }
        },
        {
          path: "/alarmplan",
          name: "alarmplan",
          components: { 
            default: () => import("@/components/stammdaten/Queries/AlarmplanSearch.vue"),
            content: () => import ("@/components/stammdaten/sideeffects/AlarmplanEdit.vue")
          }
        },
       
        {
          path: "/alarmhinweis",
          name: "alarmhinweis",
          components: { 
            default: () => import("@/components/stammdaten/Queries/AlarmHinweisSearch.vue"),
            content: () => import("@/components/stammdaten/sideeffects/AlarmHinweisEdit.vue")
          }
        },
        {
          path: "/mandant",
          name: "mandant",
          components: { 
            default: () => import("@/components/stammdaten/Queries/MandantSearch.vue"),
            content: () => import("@/components/stammdaten/sideeffects/MandantEdit.vue")
          },
          
        },     
        {
          path: "/person",
          name: "person",
          components: { 
            default: () => import("@/components/stammdaten/Queries/PersonSearch.vue"),
            content: () => import("@/components/stammdaten/sideeffects/PersonEdit.vue")
          },
          
        },
        {
          path: "/bereich",
          name: "bereich",
          components: { 
            default: () => import("@/components/stammdaten/Queries/BereichSearch.vue"),
            content: () => import("@/components/stammdaten/sideeffects/BereichEdit.vue")
          },
          
        }, 
        {
          path: "/eskalationsPartner",
          name: "eskalationsPartner",
          components: { 
            default: () => import("@/components/stammdaten/Queries/EskalationsPartnerSearch.vue"),
            content: () => import("@/components/stammdaten/sideeffects/EskalationsPartnerEdit.vue")
          }
        },
        {
          path: "/publicEskalationsPartner",
          name: "publicEskalationsPartner",
          components: { 
            default: () => import("@/components/stammdaten/Queries/PublicEskalationsPartnerSearch.vue"),
            content: () => import("@/components/stammdaten/sideeffects/PublicEskalationsPartnerEdit.vue")
          }
        },
        {
          path: "/einsatzZentrale",
          name: "einsatzZentrale",
          components: { 
            default: () => import("@/components/stammdaten/Queries/EinsatzZentraleSearch.vue"),
            content: () => import ("@/components/stammdaten/sideeffects/EinsatzZentraleEdit.vue")
          }
        },
        {
          path: "/geoObjekt",
          name: "geoObjekt",
          components: { 
            default: () => import("@/components/stammdaten/Queries/GeoObjektSearch.vue"),
            content: () => import ("@/components/stammdaten/sideeffects/GeoObjektEdit.vue")
          }
        },
        {
          path: "/weiterleitung",
          name: "weiterleitung",
          components: { 
            default: () => import("@/components/stammdaten/Queries/WeiterLeitungSearch.vue"),
            content: () => import("@/components/stammdaten/sideeffects/WeiterleitungEditPane.vue")
          }
        },
        {
          path: "/leer",
          name: "NoEdit",
          components: { 
            default: () => import("@/components/stammdaten/sideeffects/NoEdit.vue"),
            content: () => import("@/components/stammdaten/sideeffects/NoEdit.vue"),
          }
        },
        {
          path: "/codeverzeichnis",
          name: "codeVerzeichnis",
          components: { 
            default: () => import("@/components/stammdaten/Queries/CodeVerzeichnisSearch.vue"),           
          }
        },
      ]      
  },  

  {
    path: "/benutzerdaten",
    name: "benutzerdaten",    
    component: () =>
      import("@/views/Benutzerdaten.vue"),      
      children: [
        {
          path: "/Person",
          name: "pbenuzter",
          components: { 
            default: () => import("@/components/stammdaten/Queries/PersonSearch.vue"),
            content: () => import("@/components/stammdaten/sideeffects/PersonEdit.vue")
          },
          
        },
        {
          path: "/nutzerProfilRolle",
          name: "nutzerProfilRolle",
          components: { 
            default: () => import("@/components/benutzerdaten/queries/NutzerProfilRolleSearch.vue"),   
            content: () => import("@/components/benutzerdaten/sideeffects/NutzerProfilRolleEdit.vue"),            
          }
        },
        {
          path: "/nutzerProfil",
          name: "nutzerProfil",
          components: { 
            default: () => import("@/components/benutzerdaten/queries/NutzerProfilSearch.vue"), 
            content: () => import("@/components/benutzerdaten/sideeffects/NutzerProfilEdit.vue"),           
          }
        },
        {
          path: "/benutzer",
          name: "benutzer",
          components: { 
            default: () => import("@/components/benutzerdaten/queries/BenutzerSearch.vue"), 
            content: () => import("@/components/benutzerdaten/sideeffects/BenutzerEdit.vue"),
          },
          children: [
            {
              path: "/MandantBereichAnzeigePerson",
              name: "mandantBereichAnzeigePerson",
              components: { 
                info: () => import("@/components/benutzerdaten/info/MandantBereichAnzeigePerson.vue") 
              },              
            },  
            {
              path: "/MandantZuordnungPerson",
              name: "mandantZuordnungPerson",
              components: { 
                info: () => import("@/components/benutzerdaten/info/MandantZuordnungPerson.vue") 
              },              
            },  
            {
              path: "/MandantBereichZuordnungPerson",
              name: "mandantBereichZuordnungPerson",
              components: { 
                info: () => import("@/components/benutzerdaten/info/MandantBereichZuordnungPerson.vue") 
              }
            },  
            {
              path: "/RollePersonNutzerProfil",
              name: "rollePersonNutzerProfil",
              components: { 
                info: () => import("@/components/benutzerdaten/info/RollePersonNutzerProfil.vue") 
              }
            }
          
          ]          

        },
        {
          path: "/rolle",
          name: "rolle",
          components: { 
            default: () => import("@/components/benutzerdaten/queries/RolleSearch.vue"),   
            content: () => import("@/components/benutzerdaten/sideeffects/RolleEdit.vue"),         
          }
        },

      ]
    },
 
];

const router = createRouter({
  history: createWebHashHistory(),
  routes,
});

export default router;
